// extracted by mini-css-extract-plugin
export var content = "_pa-1";
export var fullScreen = "_pa-0";